export default __webpack_public_path__ + "static/media/ps-2.fdd9aee8.png";